var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHookup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "28px",
    viewBox: "0 0 25 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hookup Point") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Locate-(iPad)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hookup-Point",
    transform: "translate(0.335106, 0.000000)",
    fill: "#3904B5",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,1 C20.8284271,1 21.5784271,1.33578644 22.1213203,1.87867966 C22.6642136,2.42157288 23,3.17157288 23,4 L23,4 L23,17.5 C23,18.1295146 22.7036117,18.7222912 22.2,19.1 L22.2,19.1 L12,26.75 L1.8,19.1 C1.29638831,18.7222912 1,18.1295146 1,17.5 L1,17.5 L1,4 C1,3.17157288 1.33578644,2.42157288 1.87867966,1.87867966 C2.42157288,1.33578644 3.17157288,1 4,1 L4,1 Z",
    id: "Pin"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHookup);
export default __webpack_public_path__ + "static/media/hookup.6af87d397e26fb9c3926f2068eb785c0.svg";
export { ForwardRef as ReactComponent };